import React from 'react';
import '../../App.css';
import './Home.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import HomeVideoSection from './HomeVideoSection';
import Offer from "../Offer";
import Footer from '../Footer';
import StatsSection from '../StatsSection';
import UpcomingEvents from '../UpcomingEvents';
import Newsletter from '../Newsletter';
import LatestInfo from '../LatestInfo';
import Register from '../Register';
import aboutImage from './assets/image.png';

function Home() {
  return (
    <main>
      <HeroSection 
        title="Nem vagy egyedül. Együtt könnyebb a beszéd."
        text="Sok dadogó érintett nő fel úgy, hogy nem is tudja: vannak sorstársai. Ennek egyik oka, hogy sok dadogó személy rejtőzködik, nem vállalja fel mások előtt ezt az állapotot, inkább „elkerülő életet” alakít ki. Pedig a globális statisztikák szerint bőven vannak sorstársaink: az emberiség minimum 1%-a dadog. Ez Magyarországon közel 100 ezer embert jelent – nem számítva a határon túli magyarlakta területeket és más országokat, ahol szintén élnek dadogó érintettek. Találjuk meg egymást, és fogjunk össze!"
        showButton={false}
      />
      <HomeVideoSection />

      <section className="about-us-section">
        <div className="about-us-container">
          <div 
            className="about-us-image"
            style={{ backgroundImage: `url(${aboutImage})` }}
          ></div>

          <div className="about-us-text">
            <h2 className="heading-md">Kik vagyunk?</h2>
            <p>
              Olyan dadogó érintettek vagyunk, akiket összeköt ez az állapot, és aktívan szeretnénk tenni önmagunkért és egymásért. 
              2024-ben alakultunk hivatalos egyesületté, és azóta már számtalan izgalmas programot szerveztünk személyesen és online. 
              Fontos feladatunknak tartjuk, hogy változatos kommunikációs felületeken meg tudjuk jeleníteni a dadogó emberek hangját, 
              és minél több érintett találjon támogató közösségre nálunk. Ezzel a társadalmi szemléletet is szeretnénk formálni, 
              mivel máig nagyon sok tévhit él a dadogó emberekkel kapcsolatban.
            </p>
            <a href="/about" className="button-secondary">Olvass rólunk többet</a>
          </div>
        </div>
      </section>

      <Offer />
      <StatsSection />
      <UpcomingEvents />
      <Newsletter />
      <LatestInfo />
      <Register />
      <Footer />
    </main>
  );
}

export default Home;
